/**
 * Sticky mobile add-to-cart bar for product pages.
 * Phase 1 CRO build (2026-07-16) — new element, not a rework of an existing one.
 *
 * Does NOT implement its own cart logic. It locates the theme's existing
 * add-to-cart form/button inside the main product-information section and
 * reuses it (native click -> existing AJAX cart add / cart-drawer behavior),
 * and mirrors the live price text via the theme's `variant:update` event
 * (see assets/events.js -> ThemeEvents.variantUpdate) so the price shown in
 * the sticky bar always matches the currently selected variant.
 */
(function () {
  'use strict';

  if (window.__dcStickyAtcInitialized) return;
  window.__dcStickyAtcInitialized = true;

  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    var buyBtn = bar.querySelector('[data-sticky-atc-button]');

    var mainScope = document.querySelector('.product-information');
    if (!mainScope) return;

    function getMainForm() {
      return mainScope.querySelector('form[data-type="add-to-cart-form"]');
    }

    function getMainAddToCartButton() {
      var form = getMainForm();
      return form ? form.querySelector('button[name="add"]') : null;
    }

    function syncButtonState() {
      var mainBtn = getMainAddToCartButton();
      if (!buyBtn || !mainBtn) return;
      buyBtn.disabled = mainBtn.disabled;
      var textEl = buyBtn.querySelector('[data-sticky-atc-button-text]');
      var mainTextEl = mainBtn.querySelector('.add-to-cart-text__content');
      if (textEl && mainTextEl) {
        textEl.textContent = mainTextEl.textContent.trim();
      }
    }

    function syncPrice() {
      if (!priceEl) return;
      var mainPrice = mainScope.querySelector('[ref="priceContainer"] .price');
      if (mainPrice) {
        priceEl.textContent = mainPrice.textContent.trim();
      }
    }

    // Initial sync on load
    syncPrice();
    syncButtonState();

    // Keep price + button state in sync with the real variant picker.
    // 'variant:update' bubbles to document (see assets/events.js).
    document.addEventListener('variant:update', function () {
      // Let the theme's own listeners (e.g. product-price.js) finish
      // swapping DOM nodes first, then re-read.
      requestAnimationFrame(function () {
        syncPrice();
        syncButtonState();
      });
    });

    // Clicking the sticky button triggers the theme's real add-to-cart
    // button — same form, same AJAX cart add, same cart-drawer open.
    if (buyBtn) {
      buyBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var mainBtn = getMainAddToCartButton();
        if (mainBtn && !mainBtn.disabled) {
          mainBtn.click();
        }
      });
    }

    // Only show the sticky bar once the real add-to-cart button has
    // scrolled out of view, so we're never showing two CTAs at once.
    var observeTarget = mainScope.querySelector('product-form-component') || getMainAddToCartButton();
    if (observeTarget && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(observeTarget);
    } else {
      bar.classList.add('sticky-atc--visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
